import Route from '@/generated/classes/Route';

// Mémorise la route de retour vers la liste des contrats d'un salarié quand on ouvre le détail
// d'un contrat depuis cette liste (clic de ligne). La navigation "Retour" du détail du contrat
// est gérée par module (ModuleBase.back, généré) et ne sait pas revenir dans un AUTRE module ;
// on stocke donc ici l'origine pour que FicheProjetContratsExtend.back() puisse y retourner.
//
// Un seul créneau (dernier contrat ouvert depuis une liste salarié), associé à l'id du contrat :
// l'entrée n'est consommée que si le "Retour" concerne bien ce contrat, et elle est effacée à la
// consommation (évite de rediriger un contrat atteint normalement dans le module Projet).
let pending: { contratId: number; route: Route } | null = null;

export function setSalarieContratReturn(contratId: number, route: Route): void {
  pending = { contratId, route };
}

export function takeSalarieContratReturn(contratId: number): Route | null {
  if (pending && pending.contratId === contratId) {
    const route = pending.route;
    pending = null;
    return route;
  }
  return null;
}

// 2ᵉ niveau de retour : depuis le détail du contrat, on repasse par la fiche Salarié (pour
// reconstruire la pile d'historique du module SALARIE, détruite par l'aller-retour inter-module)
// puis la fiche Salarié rouvre la liste par-dessus. Ainsi le "Retour" natif de la liste revient
// à la fiche Salarié (pile [SALARIE_ABSTRACT, CONTAINER]) au lieu d'aller à l'Accueil.
// pendingReopen porte la route du conteneur de la liste, consommée par FicheSalarieAbstractExtend.
let pendingReopen: Route | null = null;

export function setPendingReopenSalarieContrats(route: Route): void {
  pendingReopen = route;
}

export function takePendingReopenSalarieContrats(): Route | null {
  const route = pendingReopen;
  pendingReopen = null;
  return route;
}
